import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import {
  getCollectionMethodTitle,
  getRadioOptionPanel,
  getRadioOptionsPanel,
  getTitlePanel,
  dispositionOptionInstruction,
  dispostionInstructionPayOnArrival,
  dispositionOptionTitle,
} from '../sharedTemplates/CheckoutDispositionOptionsViewTemplates';
import SharedConstants, {
  CHECKOUT_CONSTANTS,
  PICKUP_COLLECTION_METHOD
} from 'common/constants/SharedConstants';
import { isPickupDisposition } from 'common/utilities/utils';
import { isEmpty } from 'lodash';
import { getAvailableCollectionPointsFromStore } from 'common/utilities/CheckoutUtils';

const CheckoutDispositionOptionsView = props => {
  const {
    typeOptions,
    checkoutDetails,
    cartReducer,
    tenantReducer,
    radioBtnChangeHandler,
    kfcToCarCollectionPointCheck,
    updateDispositionOptions,
    updateCheckoutDetails,
  } = props;
  const {
    checkoutDispositionFirstOption,
    collectionPoint,
    mobilecontactlessdeliveryenabled,
    store,
    type,
  } = checkoutDetails;
  const { cartData } = cartReducer;
  const { enablePickupMethodDuringCheckout } = tenantReducer;
  const isCurbSidePickUp = collectionPoint?.name === PICKUP_COLLECTION_METHOD.CURB_SIDE;
  const isPickupMethodEnabled = enablePickupMethodDuringCheckout && isPickupDisposition(type);
  const availableCollectionPoints = cartData?.availableCollectionPoints ||
    getAvailableCollectionPointsFromStore(store?.availableCollectionPoints);

  const getPickupOrderCollectionMethodName = methodName => {
    switch (methodName) {
    case PICKUP_COLLECTION_METHOD?.DRIVE_THRU:
      return translateWithI18Next(SharedConstants.DRIVE_THRU_PICK_UP);
    case PICKUP_COLLECTION_METHOD?.CURB_SIDE:
      return translateWithI18Next(SharedConstants.CURB_SIDE_PICK_UP);
    case PICKUP_COLLECTION_METHOD?.IN_STORE:
      return translateWithI18Next(SharedConstants.IN_STORE_PICK_UP);
      // no default
    }
    return '';
  };

  const getPickupOrderCollectionMethod = () => {
    if (isEmpty(availableCollectionPoints)) { return null; }
    availableCollectionPoints.sort((a, b) => {
      const firstCollectionPoint = a.collectionPointName || a.name;
      const secondCollectionPoint = b.collectionPointName || b.name;
      return secondCollectionPoint.toLowerCase() < firstCollectionPoint.toLowerCase() ? -1 : 1;
    });
    return (
      <>
        {availableCollectionPoints?.map(currentCollectionPoint => {
          const pickupCollectionMethod = currentCollectionPoint.collectionPointName || currentCollectionPoint.name;
          const pickupCollectionName = getPickupOrderCollectionMethodName(pickupCollectionMethod);
          return getRadioOptionsPanel({
            cartData,
            checkoutDetails,
            isCurbSidePickUp,
            kfcToCarCollectionPointCheck,
            pickupCollectionMethod,
            pickupCollectionName,
            radioBtnChangeHandler,
            type,
            updateCheckoutDetails,
          })
        })}
      </>
    )
  }
  const getHandItToMe = () => (
    <>
      {dispositionOptionTitle({
        type,
        cartData,
        kfcToCarCollectionPointCheck,
        checkoutDetails,
        updateCheckoutDetails,
        radioBtnChangeHandler,
      })}
      {dispostionInstructionPayOnArrival({ type, checkoutDetails, updateCheckoutDetails })}{' '}
    </>
  );
  return (
    <div className={`row row-cols-12 mt-10px`}>
      {isPickupMethodEnabled ?
        getCollectionMethodTitle(translateWithI18Next(SharedConstants.PICK_UP_COLLECTION_METHOD), 'pickup-collection-method-label') :
        getTitlePanel(type, translateWithI18Next(typeOptions(type)))}
      <div className={`deliveryOptionsContent px-25px col-12 ${isPickupMethodEnabled ? 'pickup-method-options-content col-lg-8' : 'col-sm-8'}`}>
        {checkoutDispositionFirstOption === CHECKOUT_CONSTANTS?.HAND_IT_TO_ME && getHandItToMe()}

        {!isPickupMethodEnabled && mobilecontactlessdeliveryenabled &&
          getRadioOptionPanel({
            type,
            checkoutDetails,
            radioBtnChangeHandler,
            updateCheckoutDetails,
            cartData,
            kfcToCarCollectionPointCheck,
          })}

        {isPickupMethodEnabled && getPickupOrderCollectionMethod()}

        {!isPickupMethodEnabled && checkoutDispositionFirstOption !== CHECKOUT_CONSTANTS?.HAND_IT_TO_ME && getHandItToMe()}

        {!isPickupMethodEnabled && dispositionOptionInstruction({
          type,
          cartData,
          kfcToCarCollectionPointCheck,
          checkoutDetails,
          updateDispositionOptions,
        })}
      </div>
    </div>
  );
};

export default React.memo(CheckoutDispositionOptionsView);
